// extracted by mini-css-extract-plugin
export var chevron = "_2z-2";
export var chevronCollapsed = "_2z-3";
export var collapsibleHeader = "_2z-1";
export var container = "_2z-0";